<template>
  <div>
    <div class="p-6 pt-2 sidebar-scrollable-form">
      <!-- <pre>{{invoiceSidebarData}}</pre> -->

      <img :src="appLogo || '@/assets/images/logo/web-logo.png'" style="height: 80px; object-fit: contain;" />
      <div class="flex items-center justify-between">
        <div>
          <strong>Date Issued: </strong>
          <p>{{ invoiceSidebarData.created_at | dateFormatLocalization }}</p>
        </div>
      </div>
      <vs-divider />

      <!-- <div>
        <small>{{invoiceSidebarData.course_name}}</small>
      </div>
      <vs-divider /> -->

      <vs-row>
        <vs-col class="px-4" vs-lg="6" vs-sm="12" vs-xs="12" v-if="platformCustomerInfo">
          <strong>Bill from</strong>
          <p class="my-2">
            <span v-if="platformCustomerInfo.brand_company_name">{{platformCustomerInfo.brand_company_name}}</span>
            <!-- {{ get_userinfo_data.first_name }}{{ get_userinfo_data.last_name }} -->

            <!-- <pre>{{platformCustomerInfo}}</pre> -->
          </p>
          <p v-if="platformCustomerInfo.email">{{platformCustomerInfo.email}}</p>
          <p v-if="platformCustomerInfo.phone">{{platformCustomerInfo.phone}}</p>
          <address>{{ platformCustomerInfo.address1 }}</address>
          <address>{{ platformCustomerInfo.address2 }}</address>
          <p>{{ platformCustomerInfo.state }}</p>
          <p>{{ platformCustomerInfo.city }}</p>
          <p>{{ platformCustomerInfo.zip }}</p>
          <p>{{ platformCustomerInfo.country_details.country_name }}</p>

          
        </vs-col>
        <vs-col class="px-4" vs-lg="6" vs-sm="12" vs-xs="12">
          <strong>Bill to</strong>
          <p class="my-2">
            {{ invoiceSidebarData.clientUser.first_name }}
            {{ invoiceSidebarData.clientUser.last_name }}
          </p>
          <p>{{ invoiceSidebarData.clientUser.email }}</p>
          <p>{{ invoiceSidebarData.clientUser.mobile }}</p>
          <address>
            {{ invoiceSidebarData.clientUser.client_user_address.address1 }}
          </address>
          <address>
            {{ invoiceSidebarData.clientUser.client_user_address.address2 }}
          </address>
          <address>
            {{ invoiceSidebarData.clientUser.client_user_address.zip }}
          </address>
          <address>
            {{ invoiceSidebarData.country.country_name }}
          </address>

          
        </vs-col>
      </vs-row>
      <vs-divider />

      <table class="invoice-table">
        <tr>
          <th>Course Name</th>
          <!-- <th></th> -->
          <!-- <th>Description</th> -->
          <th>Price</th>
        </tr>
        <tr>
          <td>{{ invoiceSidebarData.course_name }}</td>
          <!-- <td></td> -->
          <!-- <td>Instrumental Elite: Guitar</td> -->
          <td>
            <span> <span>{{ invoiceSidebarData.currency_code.toUpperCase()}}&nbsp;</span>{{ invoiceSidebarData.amount }}</span>
          </td>
        </tr>
        <!-- <tr>
          <th>Subtotal</th>
          <td>
            <span>&#163; 00.00</span>
          </td>
        </tr>
        <tr>
          <th>Discount</th>
          <td>
            <span>&#163; 00.00</span>
          </td>
        </tr>
        <tr>
          <th>Tax</th>
          <td>0%</td>
        </tr> -->
        <tr>
          <th>Invoice Total</th>
          <td>
            <span><span>{{ invoiceSidebarData.currency_code.toUpperCase()}}&nbsp;</span>{{ invoiceSidebarData.amount }}</span>
          </td>
        </tr>
        <!-- <tr> 
          <th>Paid to date</th>
          <td>
            <span>&#163; {{ invoiceSidebarData.amount }}</span>
          </td>
        </tr>
        <tr>
          <th>Balance (USD)</th>@
          <td>
            <span>&#163; {{ invoiceSidebarData.amount }}</span>
          </td>
        </tr> -->
      </table>
      <vs-divider />

      <!-- <div class="text-right">
        <vs-button class="mx-1"
        @click="$emit('download')"
        >Download as PDF</vs-button>
       <vs-button class="mx-1" color="danger">Close</vs-button> -->
      <!-- </div> -->
      <div class="text-right mt-2">
      <vs-button class="mx-1"
        @click="downloadPdf()"
      >Download as PDF</vs-button>
    </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { getPdfDownloadByClient } from '@/api/finance'
export default {
  props: {
    invoiceSidebarData: {
      type: Object,
      required: true
    },
    schoolAddress: {
      type: Object,
      required: true
    },
    platformCustomerInfo:{
      type: Object,
      required: true
    }
  },
  data () {
    return {
      appLogo: '',
      currency_code:JSON.parse(localStorage.getItem('localization'))
        .currency.currency_symbol
    }
  },
  mounted () {
    this.appLogo = JSON.parse(localStorage.getItem('localization')).logo
  },
  methods:{
    async downloadPdf () {
      console.log('hi')
      console.log(this.invoiceSidebarData)
      const payload = {
        id:this.invoiceSidebarData.id
      }
      console.log(payload)
      const {data} = await getPdfDownloadByClient(
        localStorage.getItem('customer_id'), payload)
        console.log(data)
      console.log(data.data.url)

      // this.downloadItem(data.data.url, 'label')
      this.downloadItem({'url':data.data.url, 'label':'ClientFinancePay'})

    
    },
     downloadItem ({ url, label }) {
      axios.get(url, { responseType: 'blob' })
        .then(response => {
          console.log(response)
          const blob = new Blob([response.data], {type:'mime'})
          // const blob = new Blob([response.data], { type: 'application/pdf' })

          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = `${label}.${url.split('.')[url.split('.').length - 1]}`
          console.log(link)
          link.click()
          URL.revokeObjectURL(link.href)
        }).catch(console.error)
    },
  }
}
</script>

<style lang="scss" scoped>
</style>